import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, concatMap, map, mergeMap, switchMap, toArray } from "rxjs/operators";
import { UserProfileService } from "src/app/_services/userprofile.service";
import { DeleteLearners, DeleteLearnersError, DeleteLearnersSuccess, GetCurrentPageNumber, GetCurrentPageNumberError, GetCurrentPageNumberSuccess, GetGroupLearnerCount, GetGroupLearnerCountError, GetGroupLearnerCountSuccess, GetLearnerTable, GetLearnerTableError, GetLearnerTableLength, GetLearnerTableLengthError, GetLearnerTableLengthSuccess, GetLearnerTableSuccess, ResetLearnerTable, ResetLearnerTableError, ResetLearnerTableSuccess, SetMultipleLearnerIds, SetMultipleLearnerIdsSuccess, UpdateLearnerTable, UpdateLearnerTableError, UpdateStatus, UpdateStatusError, UpdateStatusSuccess } from "./learner.actions";
import { LearnerList } from "src/app/_models/LearnerList";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";

@Injectable()
export class LearnerEffects {
  constructor(private action$: Actions, private userProfileService: UserProfileService) {}

    public getLearnerTableEffect$ = createEffect(() =>
        this.action$.pipe(
            ofType(GetLearnerTable),
            switchMap((payload) =>
                this.userProfileService.getLearnerTableRecords$(payload.pageNumber, payload.isInitialLoad, payload.isFromTutorPage).pipe(
                    map((result: LearnerList[]) => {
                        return GetLearnerTableSuccess({ result: result });
                    }),
                    catchError((error: HttpErrorResponse) => {
                        return of(GetLearnerTableError({ learnerTableError: error }));
                    })
                )
            )
        )
    );

    public getLearnerTableLengthEffect$ = createEffect(() =>
        this.action$.pipe(
            ofType(GetLearnerTableLength),
            switchMap(() =>
                this.userProfileService.getLearnerListLength$().pipe(
                    map((length: number) => {
                        return GetLearnerTableLengthSuccess({ length: length });
                    }),
                    catchError((error: any) => {
                        return of(GetLearnerTableLengthError({ error: error }));
                    })
                )
            )
        )
    );

    public getCurrentPageNumberEffect$ = createEffect(() =>
        this.action$.pipe(
            ofType(GetCurrentPageNumber),
            switchMap((payload) =>
                this.userProfileService.getCurrentPageNumber$(payload.pageIndex).pipe(
                    map((currentPageNumber: number) => {
                        return GetCurrentPageNumberSuccess({ currentPageNumber: currentPageNumber });
                    }),
                    catchError((error: any) => {
                        return of(GetCurrentPageNumberError({ error: error }));
                    })
                )
            )
        )
    );

    public updateLearnerTableEffect$ = createEffect(() =>
        this.action$.pipe(
            ofType(UpdateLearnerTable),
            switchMap((payload) =>
                this.userProfileService.updateLearnerTableRecords$(payload.params, payload.isFromTutorPage).pipe(
                    map(() => {
                        return GetLearnerTable({
                            pageNumber: payload.params.pageIndex,
                            isInitialLoad: false,
                            isFromTutorPage: payload.isFromTutorPage
                        });
                    }),
                    catchError((error: any) => {
                        return of(UpdateLearnerTableError({ error: error }));
                    })
                )
            )
        )
    );

    public resetLearnerTableEffect$ = createEffect(() =>
        this.action$.pipe(
            ofType(ResetLearnerTable),
            switchMap((payload) =>
                this.userProfileService.resetLearnerTable$().pipe(
                    map(() => {
                        return ResetLearnerTableSuccess({
                            isInitialLoad: payload.isInitialLoad,
                        });
                    }),
                    catchError((error: HttpErrorResponse) => {
                        return of(ResetLearnerTableError({ error: error }));
                    })
                )
            )
        )
    );

    public updateMyStatus$ = createEffect(() => {
        return this.action$.pipe(
            ofType(UpdateStatus),
            mergeMap((data) => {
                return of(...data.params).pipe(
                    concatMap(request => this.userProfileService.updateAccountStatus$(request.userProfileIds, request.isDisable)),
                    toArray(),
                    map((result: boolean[]) => {
                        if(result.every(isSuccess => isSuccess))
                        {
                            return UpdateStatusSuccess( { isUpdatedSuccessFully: true } )
                        }
                        else
                        {
                            return UpdateStatusSuccess( { isUpdatedSuccessFully: false } )
                        }
                    }),
                    catchError((error: any) => {
                        return of(UpdateStatusError({error: error}));
                    })
                );
            })
        );
    });

    public getGroupLearnerCountEffect$ = createEffect(() =>
        this.action$.pipe(
            ofType(GetGroupLearnerCount),
            switchMap(() =>
                this.userProfileService.getGroupLearnerCount$().pipe(
                    map((result: string) => {
                        return GetGroupLearnerCountSuccess({
                            result: result
                        });
                    }),
                    catchError((error: HttpErrorResponse) => {
                        return of(GetGroupLearnerCountError({ error: error }));
                    })
                )
            )
        )
    );

    public deleteLearnerEffect$ = createEffect(() => {
        return this.action$.pipe(
            ofType(DeleteLearners),
            mergeMap((data) => {
                return of(...data.params).pipe(
                    concatMap(request => this.userProfileService.deleteLearners$(request.learnerIds)),
                    toArray(),
                    map((result: boolean[]) => {
                        if(result.every(isSuccess => isSuccess))
                        {
                            return DeleteLearnersSuccess({ isDeletedSuccessFully: true});
                        }
                        else
                        {
                            return DeleteLearnersSuccess({ isDeletedSuccessFully: false});
                        }
                    }),
                    catchError((error: any) => {
                        return of(DeleteLearnersError({ error: error }));
                    })
                );
            })
        )
    });

    public loadMultipleLearnerIdsEffect$ = createEffect(() =>
      this.action$.pipe(
        ofType(SetMultipleLearnerIds),
        map(() => {
          return SetMultipleLearnerIdsSuccess();
        })
      )
    );
}